module.exports = __webpack_public_path__ + "static/media/img12.147a9894.jpg";